import React from "react";

import Backdrop from "./Backdrop";

import styled from "styled-components";

const Notifications = styled.div`
  width: 25%;
  height: 80vh;
  position: fixed;
  z-index: 7000;
  box-sizing: border-box;
  padding: 20px 10px;
  top: 56px;
  left: calc(65%);
  background: white;
  border-radius: 5px;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  @media (min-width: 1600px) {
    width: 12%;
    left: calc(68%);
  }
  @media (max-width: 789px) {
    width: 100%;
    left: calc(0%);
    top: 0;
    height: 100%;
    border-radius: 0px;
  }
`;

const notificationModal = (props) => (
  <div>
    <Backdrop show={props.show} clicked={props.clicked} />
    <Notifications
      style={{
        transform: props.show ? "translateY(0)" : "translateY(-100vh)",
        opacity: props.show ? "1" : "0",
      }}
    >
      {props.children}
    </Notifications>
  </div>
);

export default notificationModal;
